import { createAction, props } from '@ngrx/store';

export const loadUserAccessFromToken = createAction('[Security] Load User Access From Token');

export const setRoles = createAction('[Security] Set Roles', props<{ roles: string[] }>());
export const setPermissions = createAction('[Security] Set Permissions', props<{ permissions: string[] }>());

export const setUserAccess = createAction(
  '[Security] Set User Access',
  props<{ roles: string[]; permissions: string[] }>()
);
